// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').Click} Click
 * @typedef {import('../index').DroppedBeatDomEventsSystem} DroppedBeatDomEventsSystem
 * @typedef {import('../types/system').DomEvents} DomEvents
 */

/**
 * @type {function(PlottrState): DomEvents}
 */
const domEventsSelector = createSelector(fullSystemStateSelector, ({ domEvents }) => {
  return (
    domEvents ?? {
      lastClick: {
        x: null,
        y: null,
        counter: 0,
      },
      droppedBeat: {
        coord: null,
        id: null,
      },
    }
  )
})

/**
 * @type {function(PlottrState): Click}
 */
export const lastClickSelector = createSelector(domEventsSelector, ({ lastClick }) => {
  return lastClick
})

/**
 * @type {function(PlottrState): DroppedBeatDomEventsSystem}
 */
export const droppedBeatSelector = createSelector(domEventsSelector, ({ droppedBeat }) => {
  return droppedBeat
})
